import styled from 'styled-components';

import { ContainerSection } from '@components/_global/GlobalStyle/Global.styled';
import { ButtonIconText } from '@components/_universal/ButtonIconText/ButtonIconText';
import { IconWrapper } from '@components/_universal/ButtonIconText/ButtonIconText.styled';
import { Card } from '@components/molecules/Card/Card';

import { breakpoints } from '@shared/constants';

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 40px 0 0 auto;
    max-width: 650px;

    @media (max-width: ${breakpoints.md}px) {
        bottom: 60px;
        margin-top: 0;
        position: fixed;
        right: 15px;
        z-index: 9;

        ${IconWrapper} {
            margin-left: 0;
        }
    }
`;

export const ButtonIconTextElement = styled(ButtonIconText)`
    padding: 0;
`;

export const ButtonTextWrapper = styled.span`
    @media (max-width: ${breakpoints.md}px) {
        display: none;
    }
`;

export const CreateReportContainerSection = styled(ContainerSection)`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 100%;
`;

export const StatusCard = styled(Card)`
    @media (max-width: ${breakpoints.md}px) {
        max-width: 555px;
    }
`;
